
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import * as api from '../services/api'

const initialState = {
  release: {},
  regeneratingSummary: false,
  searchResults: null,
  searchString: '',
  errorMessage: null // http error message
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'news.getRelease': {
      // console.log('news.getRelease action:', action)
      return {
        ...state,
        release: {
          _id: null, // Set to null while we are getting the release
        },
      }
    }

    case 'news.setRelease': {
      // console.log('news.setRelease action:', action)
      return {
        ...state,
        release: action.release
      }
    }

    case 'news.regenerateSummary': {
      // console.log('news.regenerateSummary action:', action)
      return {
        ...state,
        regeneratingSummary: true,
      }
    }

    case 'news.setRegeneratingSummary': {
      // console.log('news.setRegeneratingSummary action:', action)
      return {
        ...state,
        regeneratingSummary: action.regeneratingSummary,
      }
    }

    case 'news.setMeta': {
      // console.log('news.setMeta action:', action)
      return {
        ...state,
        meta: action.meta,
      }
    }

    case 'news.setSearchResults': {
      // console.log('news.setSearchResults action:', action)
      return {
        ...state,
        errorMessage: action.errorMessage,
        searchResults: action.results,
        searchString: action.searchString,
      }
    }

    default: {
      return state
    }
  }
}

function* handleGetMeta(props) {
  try {
    const meta = yield call(api.news.getMeta, props)
    yield put(actions.setMeta({ meta }))
  } catch (error) {
    console.log('watchGetMeta:', error)
  }
}

function* handleGetRelease(props) {
  try {
    const release = yield call(api.news.getRelease, props)
    yield put(actions.setRelease({ release }))
  } catch (error) {
    console.log('watchGetRelease:', error)
  }
}

function* handleRegenerateSummary(props) {
  try {
    yield call(api.news.regenerateSummary, props)
    const release = yield call(api.news.getRelease, props)
    yield put(actions.setRelease({ release }))
  } catch (error) {
    console.log('handleRegenerateSummary:', error)
  } finally {
    yield put(actions.setRegeneratingSummary({ regeneratingSummary: false }))
  }
}

function* handleSetFavouriteByLei({ newsMeta, lei, isFavourite }) {
  // NB: We are currently using 'favourite' for news as opposed to 'isFavourite'
  const meta = newsMeta.map(item => {
    if (item.lei === lei)
      item.favourite = isFavourite
    return item
  })
  yield put(actions.setMeta({ meta }))
}

function* handleSetFavouriteByCompanyNumber({ newsMeta, companyNumber, isFavourite }) {
  // NB: We are currently using 'favourite' for news as opposed to 'isFavourite'
  const meta = newsMeta.map(item => {
    if (item.number === companyNumber)
      item.favourite = isFavourite
    return item
  })
  yield put(actions.setMeta({ meta }))
}

function* handleSearchDocument({ searchString }) {
  if (searchString === "") {
    yield put(actions.setSearchResults({ results: null, searchString }))
  } else {
    try {
      const results = yield call(api.news.searchDocument, { searchString })
      yield put(actions.setSearchResults({ errorMessage: null, results, searchString }))
    } catch (error) {
      yield put(actions.setSearchResults({ errorMessage: error.message, results: null, searchString }))
    }
  }
}

//#region actions, selectors and sagas
export const actions = {
  getMeta: props => ({ ...props, type: 'news.getMeta' }),
  setMeta: props => ({ ...props, type: 'news.setMeta' }),

  getRelease: props => ({ ...props, type: 'news.getRelease' }),
  setRelease: props => ({ ...props, type: 'news.setRelease' }),

  regenerateSummary: props => ({ ...props, type: 'news.regenerateSummary' }),
  setRegeneratingSummary: props => ({ ...props, type: 'news.setRegeneratingSummary' }),

  setFavouriteByLei: props => ({ ...props, type: 'news.setFavouriteByLei' }),
  setFavouriteByCompanyNumber: props => ({ ...props, type: 'news.setFavouriteByCompanyNumber' }),

  setSearchResults: props => ({ ...props, type: 'news.setSearchResults' }),
  searchDocument: props => ({ ...props, type: 'news.searchDocument' }),
}

export const selectors = {
}

export function* sagas() {
  yield all([
    takeLatest('news.getMeta', handleGetMeta),
    takeLatest('news.getRelease', handleGetRelease),
    takeLatest('news.regenerateSummary', handleRegenerateSummary),
    takeEvery('news.setFavouriteByLei', handleSetFavouriteByLei),
    takeEvery('news.setFavouriteByCompanyNumber', handleSetFavouriteByCompanyNumber),
    takeLatest('news.searchDocument', handleSearchDocument),
  ])
}
//#endregion
